<template>
  <div class="page-body space-y-1">
    <p class="h3-title">【C】数字化成效维度</p>
    <p class="font-heiti pt-3">C1 绿色低碳</p>
    <p>{{info.p_b_1}}</p>
    <p>{{info.p_b_2}}</p>
    <p>{{info.p_b_3}}</p>
    <p>{{info.p_b_4}}</p>
    <p class="font-heiti pt-3">C2 产品质量</p>
    <p>{{info.p_b_5}}</p>
    <p>{{info.p_b_6}}</p>
    <p>{{info.p_b_7}}</p>
    <p class="font-heiti pt-3">C3 市场效益</p>
    <p>{{info.p_b_8}}</p>
    <p class="text-bold pt-3">——C31 市场表现</p>
    <p>{{info.p_b_9}}</p>
    <p>{{info.p_b_10}}</p>
    <p>{{info.p_b_11}}</p>
    <p>{{info.p_b_12}}</p>
    <p class="text-bold pt-3">——C32 价值效益</p>
    <p>{{info.p_b_13}}</p>
    <p>{{info.p_b_14}}</p>
    <p>{{info.p_b_16}}</p>
    <p>{{info.p_b_17}}</p>
  </div>
</template>

<script>

// 数字化成效维度1
export default {
  props: ['info']
}
</script>
